import { render, staticRenderFns } from "./AutocompleteQuestionTags.vue?vue&type=template&id=4292bfa2&lang=pug"
import script from "./AutocompleteQuestionTags.vue?vue&type=script&lang=js"
export * from "./AutocompleteQuestionTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports